import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';

import { FilterFormsModalPage } from './forms-filter';

@NgModule({
    declarations: [
        FilterFormsModalPage,
    ],
    imports: [
        IonicPageModule.forChild(FilterFormsModalPage),
    ],
    entryComponents: [
        FilterFormsModalPage,
    ]
})
export class FilterFormsModule { }


// WEBPACK FOOTER //
// ./src/pages/forms/forms-filter.module.ts